import React from 'react';
import StringProperty from '../properties/StringProperty';
import SetObjectNameAction from '../../actions/SetObjectNameAction';
import SetVisibilityModeAction from '../../actions/SetVisibilityModeAction';
import SetValueAction from '../../actions/SetValueAction';
import PropertyBase from '../properties/PropertyBase';
import DropdownProperty from '../properties/DropdownProperty';
import { RenderModes, CustomEventTypes, ObjectInspectorSectionTypes } from '../../globals';
import PropertyGroup from '../properties/PropertyGroup';
import BoolProperty from '../properties/BoolProperty';
import VisibilityManager from '../../classes/VisibilityManager';
import SyncedProperty from '../properties/SyncedProperty';
import {GroupsManager} from '../../classes/GroupsManager'
import AddToGroupAction from '../../actions/AddToGroupAction';
import RemoveFromGroupAction from '../../actions/RemoveFromGroupAction';
import SetObjectGroupsAction from '../../actions/SetObjectGroupsAction';
import ObjectPropertiesPasteAction from '../../actions/ObjectPropertiesPasteAction';
import store, { StoreActions } from '../../state/store';
import MaterialAsset from '../../classes/MaterialAsset';
import AssetProperty from '../properties/AssetProperty';
import ARTracker from '../../classes/ARTracker';
import Button from '../layout/Button';
import ObjectGroupsView from '../ObjectGroupsView';
import { TooltipKeys } from '../tooltips/TooltipKeys';
import {VisibilityModes} from "../../interfaces/enums";
import TextUtils from '../../classes/utilities/TextUtils';
import DefaultSceneManager from '../../classes/DefaultSceneManager';
import ContextMenu from '../menus/ContextMenu';
import { areArrayEqualUnordered, areArraysEqual } from '../../classes/utilities/Misc';
import { PingIcon } from '../Iconset';
import AssetsLibraryUtilities from '../filebrowser/AssetsLibraryUtilities';
import AssetsManager from '../../classes/AssetsManager';

export default class ObjectPropertiesComponent extends React.Component
{
	constructor(props)
	{
		super(props);
		this.initializeValues = this.initializeValues.bind(this);
		this.onNameChanged = this.onNameChanged.bind(this);
		this.onGroupsChanged = this.onGroupsChanged.bind(this);
		this.onNameCommitted = this.onNameCommitted.bind(this);
		this.onStandaloneVisibilityModeChanged = this.onStandaloneVisibilityModeChanged.bind(this);
		this.onDeviceVisibilityModeChanged = this.onDeviceVisibilityModeChanged.bind(this);
		this.onOverrideParentVisibilityChanged = this.onOverrideParentVisibilityChanged.bind(this);
		this.handleObjectNameChanged = this.handleObjectNameChanged.bind(this);
		this.handleVisibilityModeChanged = this.handleVisibilityModeChanged.bind(this);
		this.handleGroupListUpdated = this.handleGroupListUpdated.bind(this);
		this.onStandaloneMaterialChanged = this.onStandaloneMaterialChanged.bind(this);
		this.onDeviceMaterialChanged = this.onDeviceMaterialChanged.bind(this);
		this.copy = this.copy.bind(this);
		this.paste = this.paste.bind(this);
		this.isMultiValues = this.isMultiValues.bind(this);
		this.isARTracker = this.isARTracker.bind(this);

		this.propertyType = ObjectInspectorSectionTypes.ObjectProperties;
		this.objects = props.objects;
		this.initialNames = [];
		this.multivalues = {};
		this.trackersSelected = false;
		this.sourceAsset = null;
		this.state =
		{
		  name: "",
		  groupList: [],
		  groups: [],
		  standaloneVisibilityMode: VisibilityModes.Solid,
		  deviceVisibilityMode: VisibilityModes.Solid,
		  overrideParentVisibility: false,
			customStandaloneMaterial: undefined,
			customDeviceMaterial: undefined,
		}
	}

	componentDidMount()
	{
		document.addEventListener(CustomEventTypes.objectNameChanged, this.handleObjectNameChanged, false);
		document.addEventListener(CustomEventTypes.visibilityModeChanged, this.handleVisibilityModeChanged, false);
		document.addEventListener(CustomEventTypes.onGroupListUpdated, this.handleGroupListUpdated, false);
		document.addEventListener(CustomEventTypes.updatePropertiesComponent, this.initializeValues, false);
		this.handleGroupListUpdated();
	}

	componentWillUnmount()
	{
		document.removeEventListener(CustomEventTypes.objectNameChanged, this.handleObjectNameChanged, false);
		document.removeEventListener(CustomEventTypes.VisibilityModeChanged, this.handleVisibilityModeChanged, false);
		document.removeEventListener(CustomEventTypes.onGroupListUpdated, this.handleGroupListUpdated, false);
		document.removeEventListener(CustomEventTypes.updatePropertiesComponent, this.initializeValues, false);
	}

	handleObjectNameChanged(e)
	{
		if (!e.detail || e.detail.sender !== this)
		{
			this.initializeValues();
		}
	}

	handleVisibilityModeChanged(e)
	{
		if (!e.detail || e.detail.sender !== this)
		{
			this.initializeValues();
		}
	}

	handleGroupListUpdated(e)
	{
		let groupList = GroupsManager.getGroupList();
		let groupsDisplay = [];
		for (let group of groupList)
		{
			groupsDisplay.push({ display: group.name, value: group.guid });
		}
		this.setState({ groupList: groupsDisplay });
		this.initializeValues();
	}

	componentDidUpdate(prevProps, prevState, snapshot)
	{
		if (!areArraysEqual(this.props.objects, this.objects))
		{
			this.objects = this.props.objects;
			this.initializeValues();
		}
	}

	initializeValues()
	{
		if (this.objects.length > 0)
		{
			this.trackersSelected = false;
			for (let object of this.objects)
			{
				if (object instanceof ARTracker)
				{
					this.trackersSelected = true;
				}
			}

			this.initialNames.length = 0;
			this.initialNames.push(this.objects[0].name);

			let name = this.objects[0].name;
			let standaloneVisMode;
			let deviceVisMode;
			let overrideParent;
			let customStandaloneMaterial;
			let customDeviceMaterial;
			let groups;
			if (!this.trackersSelected)
			{
				standaloneVisMode = this.objects[0].userData.visibility[RenderModes.Standalone];
				deviceVisMode = this.objects[0].userData.visibility[RenderModes.Device];
				overrideParent = this.objects[0].userData.visibility.overrideParent;
				customStandaloneMaterial = this.objects[0].userData.visibility.customStandaloneMaterial;
				customDeviceMaterial = this.objects[0].userData.visibility.customDeviceMaterial;
				groups = this.objects[0].userData.groups ? [...this.objects[0].userData.groups] : [];
			}

			this.multivalues = {};

			for (let i = 1; i < this.objects.length; i++)
			{
				if (name !== this.objects[i].name) this.multivalues.name = true;
				if (!this.trackersSelected)
				{
					if (standaloneVisMode !== this.objects[i].userData.visibility[RenderModes.Standalone]) this.multivalues.standaloneVisibility = true;
					if (deviceVisMode !== this.objects[i].userData.visibility[RenderModes.Device]) this.multivalues.deviceVisibility = true;
					if (customStandaloneMaterial !== this.objects[i].userData.visibility.customStandaloneMaterial) this.multivalues.customStandaloneMaterial = true;
					if (customDeviceMaterial !== this.objects[i].userData.visibility.customDeviceMaterial) this.multivalues.customDeviceMaterial = true;
					if (overrideParent !== this.objects[i].userData.visibility.overrideParent) this.multivalues.overrideParentVisibility = true;
					if (!areArrayEqualUnordered(groups, this.objects[i].userData.groups ?? [])) this.multivalues.groups = true;
				}
				this.initialNames.push(this.objects[i].name);
			}

			this.setState({
				name: name,
				groups: groups,
				standaloneVisibilityMode: standaloneVisMode,
				deviceVisibilityMode: deviceVisMode,
				overrideParentVisibility: overrideParent,
				customStandaloneMaterial: customStandaloneMaterial,
				customDeviceMaterial: customDeviceMaterial,
			});
		}
	}

	onNameChanged(value)
	{
		if (this.multivalues.name && value === '~')
		{
			return;
		}
		this.multivalues.name = false;
		for (let i = 0; i < this.objects.length; i++)
		{
			this.objects[i].name = value;
		}

		this.setState({ name: value });

		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectNameChanged, { detail: { sender: this } }));
	}

	onNameCommitted(value)
	{
		if (this.multivalues.name && value === '~')
		{
			return;
		}

		let newName = this.objects[0].name;
		for (let i = 0; i < this.objects.length; i++)
		{
			this.objects[i].name = this.initialNames[i];
		}

		new SetObjectNameAction(this.objects, newName, [...this.initialNames]);
	}

	onGroupsChanged(value)
	{
		let newGroups = value;
		let oldGroups = this.state.groups;
		if (newGroups.length > oldGroups.length)
		{
			for (let newGroup of newGroups)
			{
				if (!oldGroups.includes(newGroup))
				{
					this.setState({ groups: value });
					new AddToGroupAction(newGroup, this.objects);
					break;
				}
			}
		}
		else
		{
			for (let oldGroup of oldGroups)
			{
				if (!newGroups.includes(oldGroup))
				{
					// TODO: make it drop of all groups in one go, if needed
					this.setState({ groups: value });
					new RemoveFromGroupAction(oldGroup, this.objects);
					break;
				}
			}
		}
	}

	onStandaloneVisibilityModeChanged(value)
	{
		this.setState({ standaloneVisibilityMode: value });

		if (value !== '~')
		{
			const customMaterials = [];
			for(const object of this.objects)
			{
				customMaterials.push(object.userData.visibility.customStandaloneMaterial);
			}
			new SetVisibilityModeAction(this.objects, value, RenderModes.Standalone, customMaterials);
		}
	}

	onDeviceVisibilityModeChanged(value)
	{
		this.setState({ deviceVisibilityMode: value });

		if (value !== '~')
		{
			const customMaterials = [];
			for(const object of this.objects)
			{
				customMaterials.push(object.userData.visibility.customDeviceMaterial);
			}
			new SetVisibilityModeAction(this.objects, value, RenderModes.Device, customMaterials);
		}
	}

	onStandaloneMaterialChanged(value)
	{
		this.setState({ customStandaloneMaterial: value });
		if (value !== '~')
		{
			if(value === MaterialAsset.defaultMaterialGuid)
			{
				value = undefined;
			}
			new SetVisibilityModeAction(this.objects, VisibilityModes.Custom, RenderModes.Standalone, value);
		}
	}

	onDeviceMaterialChanged(value)
	{
		this.setState({ customDeviceMaterial: value });
		if (value !== '~')
		{
			if(value === MaterialAsset.defaultMaterialGuid) value = undefined;
			new SetVisibilityModeAction(this.objects, VisibilityModes.Custom, RenderModes.Device, value);
		}
	}

	onOverrideParentVisibilityChanged(value)
	{
		this.setState({ overrideParentVisibility: value });

		let initialValues = [];
		let newValues = [];
		for (let i = 0; i < this.objects.length; i++)
		{
			initialValues.push({ object: this.objects[i], override: this.objects[i].userData.visibility.overrideParent });
			newValues.push({ object: this.objects[i], override: value });
		}

		let setFunc = Array(this.objects.length).fill(VisibilityManager.setObjectOverrideParent);
		new SetValueAction(setFunc, newValues, initialValues, this.objects.length > 1 ? "Toggled Objects Override Parent Visibility" : "Toggled Override Parent Visibility", CustomEventTypes.updatePropertiesComponent);
	}

	copy()
	{
		store.dispatch(StoreActions.application.setPropertyClipboard({ type: this.propertyType, data: { ...this.state } }));
	}

	paste()
	{
		const clipboard = store.getState().applicationModule.propertyClipboard;
		if(!clipboard || clipboard.type !== this.propertyType) return;
		new ObjectPropertiesPasteAction(this.objects, clipboard.data);
	}

	isMultiValues()
	{
		const str = JSON.stringify(this.multivalues);
		if (str.toLocaleLowerCase().includes('true')) return true;
		return false;
	}

	isARTracker()
	{
		if (this.objects[0].trackerType) return true;
		return false;
	}

	renderContent()
	{
		let k = 0;
		return (
			<>
				<SyncedProperty data-name={"property-name"}
					key={k++}
					objects={this.objects}
					getterFunc={(o) => { return o.name; }}
					resyncFunction={(targets, defValues, curValues) =>
					{
						new SetObjectNameAction(targets, defValues, curValues);
					}}
				>
					<StringProperty data-name={"property-name"}
						label="Name"
						value={this.state.name}
						defaultValue={this.trackersSelected ? "AR Tracker" : "Object"}
						multivalues={this.multivalues.name}
						readOnly={this.props.readOnly}
						characterLimit={this.props.nameCharacterLimit}
						onChangeCallback={this.onNameChanged}
						onCommitCallback={this.onNameCommitted} 
						contextMenuOverride={[]}
					/>
					
				</SyncedProperty>
				{this.objects.length === 1 && this.objects[0].userData.assetId && <PropertyBase data-name={"property-source-asset"}
					label="Source Asset">
					<div>{AssetsManager.getAssetInfo(this.objects[0].userData.assetId)?.name}</div>
					<PingIcon scale={0.7} 
						cellclass={"propertySmallCell"}
						data-name={"source-asset-select-value-button"}
						onClick={() => 
						{
							AssetsLibraryUtilities.selectAssets([this.objects[0].userData.assetId], { autoScroll: true, autoExpand: true });
						}}
						tooltip={TooltipKeys.AssetPickerSelectInLibrary}
							 />
				</PropertyBase>}
				{
					this.trackersSelected ? null :
						<>
							<SyncedProperty data-name={"property-group"}
								key={k++}
								objects={this.objects}
								getterFunc={(o) => { return o.userData.groups ?? []; }}
								comparerFunc={(a, b) => { return areArrayEqualUnordered(a, b) }}
								resyncFunction={(targets, defValues, curValues) =>
								{
									new SetObjectGroupsAction(targets, ...defValues);
								}}
							>
								<DropdownProperty data-name={"property-group"}
									value={this.state.groups}
									defaultValue={[]}
									label="Groups"
									placeholder={"Select Group..."}
									searchable
									multiSelect
									multivalues={this.multivalues.groups}
									readOnly={this.props.readOnly}
									options={this.state.groupList}
									onChangeCallback={this.onGroupsChanged}
									decorators={[
										<Button key={0}
											classname={"small fit"}
											label={"Create Group"}
											onClick={ObjectGroupsView.onCreateGroup}
										/>
									]}
									contextMenuOverride={
										[
											{
												renderObject: "Reset values",
												id: "Reset to default",
												callback: () =>
												{
													this.onGroupsChanged([]);
												},
											},
										]
									}
								/>
							</SyncedProperty>

							<SyncedProperty data-name={"property-visibility-standalone"}
								key={k++}
								objects={this.objects}
								getterFunc={(o) => { return o.userData.visibility[RenderModes.Standalone]; }}
								resyncFunction={(targets, defValues, curValues) =>
								{
									const customMaterials = Array(targets.length).fill(null);
									for(let i = 0; i < targets.length; i++)
									{
										const object = targets[i];
										const defaultObject = DefaultSceneManager.getInstance().getDefaultObject(object.userData.guid);
										if(defaultObject)
										{
											customMaterials[i] = defaultObject.userData.visibility.customStandaloneMaterial;
										}
									}
									new SetVisibilityModeAction(targets, defValues, RenderModes.Standalone, customMaterials);
								}}
							>
								<DropdownProperty data-name={"property-visibility-standalone"}
									label="Standalone Mode"
									value={this.state.standaloneVisibilityMode}
									defaultValue={VisibilityModes.Solid}
									multivalues={this.multivalues.standaloneVisibility}
									readOnly={this.props.readOnly}
									onChangeCallback={this.onStandaloneVisibilityModeChanged}
									options={
										Object.entries(VisibilityModes).map(([key, value]) =>
										{
											return { display: TextUtils.prettifyText(key), value: value };
										})
									}
									tooltip={TooltipKeys.StandaloneModeProperty}
									contextMenuOverride={
										[
											{
												renderObject: "Reset values",
												id: "Reset to default",
												callback: () =>
												{
													this.onStandaloneVisibilityModeChanged(VisibilityModes.Solid);
												},
											},
										]
									}
								/>
							</SyncedProperty>
							{
								this.state.standaloneVisibilityMode === VisibilityModes.Custom ?
									<SyncedProperty data-name={"property-material-asset"}
										objects={this.objects}
										getterFunc={(o) => { return o.userData.visibility.customStandaloneMaterial ?? null }}
										resyncFunction={(targets, defValues, curValues) =>
										{
											new SetVisibilityModeAction(targets, VisibilityModes.Custom, RenderModes.Standalone, defValues);
										}}
									>
										<AssetProperty
											data-name={"standalone-custom-material-asset"}
											label={"Custom Material"}
											value={this.state.customStandaloneMaterial}
											defaultValue={null}
											multivalues={this.multivalues.customStandaloneMaterial}
											onChangeCallback={this.onStandaloneMaterialChanged}
											buttonStyle={{ textTransform: 'none' }}
											type={"material"}
											contextMenuOverride={
												[
													{
														renderObject: "Reset values",
														id: "Reset to default",
														callback: () =>
														{
															this.onStandaloneMaterialChanged(null);
														},
													},
												]
											}
										/>
									</SyncedProperty>
									: null
							}
							<SyncedProperty data-name={"property-visibility-device"}
								key={k++}
								objects={this.objects}
								getterFunc={(o) => { return o.userData.visibility[RenderModes.Device]; }}
								resyncFunction={(targets, defValues, curValues) =>
								{
									const customMaterials = Array(targets.length).fill(null);
									for(let i = 0; i < targets.length; i++)
									{
										const object = targets[i];
										const defaultObject = DefaultSceneManager.getInstance().getDefaultObject(object.userData.guid);
										if(defaultObject)
										{
											customMaterials[i] = defaultObject.userData.visibility.customDeviceMaterial;
										}
									}
									new SetVisibilityModeAction(targets, defValues, RenderModes.Device, customMaterials);
								}}
							>
								<DropdownProperty data-name={"property-visibility-device"}
									label="Overlay Mode"
									value={this.state.deviceVisibilityMode}
									defaultValue={VisibilityModes.Solid}
									multivalues={this.multivalues.deviceVisibility}
									readOnly={this.props.readOnly}
									onChangeCallback={this.onDeviceVisibilityModeChanged}
									options={
										Object.entries(VisibilityModes).map(([key, value]) =>
										{
											return { display: TextUtils.prettifyText(key), value: value };
										})
									}
									tooltip={TooltipKeys.OverlayModeProperty}
									contextMenuOverride={
										[
											{
												renderObject: "Reset values",
												id: "Reset to default",
												callback: () =>
												{
													this.onDeviceVisibilityModeChanged(VisibilityModes.Solid);
												},
											},
										]
									}
								/>
							</SyncedProperty>
							{
								this.state.deviceVisibilityMode === VisibilityModes.Custom ?
									<SyncedProperty data-name={"property-material-asset"}
										objects={this.objects}
										getterFunc={(o) => { return o.userData.visibility.customDeviceMaterial ?? null }}
										resyncFunction={(targets, defValues, curValues) =>
										{
											new SetVisibilityModeAction(targets, VisibilityModes.Custom, RenderModes.Device, defValues);
										}}
									>
										<AssetProperty
											data-name={"device-custom-material-asset"}
											label={"Custom Material"}
											value={this.state.customDeviceMaterial}
											defaultValue={null}
											multivalues={this.multivalues.customDeviceMaterial}
											onChangeCallback={this.onDeviceMaterialChanged}
											buttonStyle={{ textTransform: 'none' }}
											type={"material"}
											contextMenuOverride={
												[
													{
														renderObject: "Reset values",
														id: "Reset to default",
														callback: () =>
														{
															this.onDeviceMaterialChanged(null);
														},
													},
												]
											}
										/>
									</SyncedProperty>
									: null
							}
							<SyncedProperty data-name={"property-visibility-override"}
								key={k++}
								objects={this.objects}
								getterFunc={(o) => { return o.userData.visibility.overrideParent; }}
								resyncFunction={(targets, defValues, curValues) =>
								{
									let initialValues = [];
									let newValues = [];
									for (let i = 0; i < targets.length; i++)
									{
										initialValues.push({ object: this.objects[i], override: this.objects[i].userData.visibility.overrideParent });
										newValues.push({ object: this.objects[i], override: defValues[i] });
									}

									const setFunc = Array(targets.length).fill(VisibilityManager.setObjectOverrideParent);
									new SetValueAction(setFunc, newValues, initialValues, this.objects.length > 1 ? "Toggled Objects Override Parent Visibility" : "Toggled Override Parent Visibility", CustomEventTypes.updatePropertiesComponent);
								}}
							>
								<BoolProperty data-name={"property-visibility-override"}
									label={"Override Parent Visibility"}
									value={this.state.overrideParentVisibility}
									defaultValue={false}
									multivalues={this.multivalues.overrideParentVisibility}
									disabled={this.props.readOnly}
									onChangeCallback={this.onOverrideParentVisibilityChanged}
									contextMenuOverride={
										[
											{
												renderObject: "Reset values",
												id: "Reset to default",
												callback: () =>
												{
													this.onOverrideParentVisibilityChanged(false);
												},
											},
										]
									}
								/>
							</SyncedProperty>
						</>
				}
			</>
		);
	}

	render()
	{
		if (!this.objects || this.objects.length === 0)
			return null;

		return (
			this.props.noGroup ? this.renderContent() :
				<PropertyGroup
					title="General"
					onContextMenu={(e) =>
					{
						e.preventDefault();
						if (this.isARTracker())
						{
							return;
						}
						else
						{
							ContextMenu.show(e, [], "Tracker", [
								{
									items:
											[
											  ...(!this.isMultiValues() ? [{
											    renderObject: "Copy",
											    id: "copy",
											    callback: this.copy,
											  }] : []),
											  ...(store.getState().applicationModule.propertyClipboard?.type === this.propertyType && !this.props.readOnly ? [{
											    renderObject: "Paste",
											    id: "paste",
											    callback: this.paste,
											  }] : [])
											],
								},
							]);
						}
					}}
				>
					{this.renderContent()}
				</PropertyGroup>
		);
	}

}
